import React, { useEffect } from "react";
import { CartContainer, CartContainerImage } from "./style.js";
import Format from "../../Layout/Format/index";
import { useDispatch, useSelector } from "react-redux";
import { FetchCart } from "../../../Actions/cartAction";

export default function CartButton() {
    const { Total } = useSelector((state) => state.cart);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(FetchCart());
    }, []);

    return (
        <CartContainer to="/cart">
            <CartContainerImage
                className="cart-button-container-image"
                src="/svg/shopping-cart.svg"
                alt="cartSvg"
            />
            <span style={{ marginTop: "0.5rem" }}>
                <Format price={Total} />
            </span>
        </CartContainer>
    );
}
